export const ApiToken = {
    // !测试站点
    // flag: false,
    // token: 'UpToken26',
    // baseUrl: 'https://events.schneider-electric.cn/ciif2026/Api',
    // baseApi: '',
    // shareUrl: 'https://events.schneider-electric.cn/ciif2026',  
    // UrlBase: '',
    // Url: '',
    // surveyTime: '2023-08-25 09: 00: 00',
    // Cpath: '/ciif2026/',

    // !正式站点
    flag: true,
    token: 'UpTokenCase26',
    baseUrl: 'https://events.schneider-electric.cn/ciif2026/Api', //正式
    baseApi: '',
    shareUrl: 'https://events.schneider-electric.cn/ciif2026',
    UrlBase: '',
    Url: '',
    surveyTime: '2023-09-19 09: 00: 00',
    Cpath: '/ciif2026/'
}
export const Res_Url = 'https://staticdn.ht-s.cn/se/ciif/2025' 
// export const Res_Url2026 = 'https://events.schneider-electric.cn/ciif2026/2026' //26年的图片资源本机
export const Res_Url2026 = 'https://staticdn.ht-s.cn/se/ciif/2026' //26年的图片资源